import { z } from "zod";

/**
 * What the store does when an item is unavailable at packing (BasketLine.substitution). Off
 * until the retailer opts in: their app may not honour a preference, so nothing is asked and
 * nothing is announced for them.
 */
export const substitutionsSchema = z
	.object({
		/**
		 * Applies to every line the shopper did not choose for; checkout and cart events report
		 * it. Unset: they report only the shopper's own choices. Not SPECIFIC: a specific
		 * replacement is always one item's own.
		 */
		default: z.enum(["SIMILAR", "NONE"]).optional(),
		/** Shoppers may choose per item or for the whole basket; the agent asks once per basket. */
		allowed: z.boolean().default(false),
	})
	.prefault({});
